import { useI18n } from '@/i18n';
import { Facebook, Instagram, Twitter, Youtube, Mail, Phone } from 'lucide-react';

export function Footer() {
  const { t } = useI18n();
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: Phone, href: 'tel:+8801846098619', label: 'Phone' },
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Youtube, href: '#', label: 'YouTube' },
    { icon: Mail, href: 'mailto:support@chocolatevibes.com', label: 'Email' },
  ];

  return (
    <footer className="bg-primary text-white mt-auto pb-[70px] lg:pb-0">
      <div className="container mx-auto px-2 py-4">
        <div className="grid grid-cols-1 gap-4">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex flex-col items-center gap-1">
              {/* <div className="w-16 h-16 bg-primary rounded-full flex overflow-hidden shrink-0">
                <img src="/icons/logo-3.png" alt="Logo" className="w-full h-full object-cover" />
              </div> */}
              <span className="text-4xl font-bold mt-4">{t('app.name')}</span>
              <p className="text-white text-[12px] font-medium leading-relaxed">{t('app.description')}</p>
            </div>
          </div>
          {/* Legal & Social */}
          <div className="flex flex-col items-center justify-center">
            <div className="text-center">
              <h3 className="font-medium mb-2">{t('footer.follow_us')}</h3>
              <div className="flex gap-3 justify-center">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    className="w-10 h-10 rounded-full bg-white flex items-center justify-center hover:bg-primary transition-colors"
                    aria-label={social.label}
                  >
                    <social.icon className="h-5 w-5 text-primary" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white mt-4 pt-4 flex flex-col sm:flex-row justify-center items-center gap-2">
          <p className="text-xs text-white">
            {t('footer.copyright', { year: currentYear })}
          </p>
        </div>
      </div>
    </footer>
  );
}
